module.exports = __webpack_public_path__ + "static/img/10016 (2).0b14499.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10016 (2).webp
// module id = fv3d
// module chunks = 14